import React from "react";
import NavBar from "../components/layout/NavBar";
import FooterGradient from "../components/layout/Footer";
import aboutBg from "../images/hero-about.png"

const TEAM = [
  {
    name: "Kinan Faure",
    role: "Président",
    photo: "https://pacte-claix.fr/assets/images/PPKF%20v2.jpg",
    bio: "« J'ai fondé le PACTE avec la volonté de proposer quelque chose de nouveau pour Claix. Je prends un grand plaisir à discuter avec les commerçants et les habitants au sujet de ce projet local. Au plaisir d'échanger à Claix ! »",
  },
  {
    name: "Martin Colas-Roy",
    role: "Secrétaire Général",
    photo: "https://pacte-claix.fr/assets/images/PPMCR%20V2.jpg",
    bio: "« Étudiant en classe prépa commerciale, je suis fier d’accompagner ce projet promouvant l’économie claixoise. Je suis convaincu que c’est en favorisant le circuit-court que nous pouvons rétablir la proximité entre les commerçants et les habitants et accélérer la transition écologique. »",
  },
  {
    name: "Lucas Coudert",
    role: "Trésorier",
    photo: 'https://pacte-claix.fr/assets/images/PPLC%20v2.jpg',
    bio: "« Jeune étudiant en prépa scientifique, j'avais l'envie de m'investir dans un projet qui avait du sens. Le PACTE est pour moi un projet porteur de valeurs qui me tiennent à coeur. »",
  },
  {
    name: "Jules Guillaume",
    role: "Responsable communication",
    photo: "https://pacte-claix.fr/assets/images/PPJG%20v2.jpg",
    bio: "« N'étant pas d'origine iséroise, j'ai cherché à m'investir dans plusieurs projets lors de mon arrivée sur Grenoble pour mes études scientifiques. Kinan FAURE m'a alors parlé et présenté ce PACTE. J'ai décidé de prendre parti à ce projet notamment pour les valeurs et idées concrètes qu'il véhicule, à savoir : soutien envers les commerçants, entraide et surtout favoriser les circuits courts dans le but de réduire notre consommation énergétique. »",
  },
  {
    name: "Adrien Candela",
    role: "WebMaster",
    photo: "https://i.ibb.co/kTsHsSb/adrien.png",
    bio: "« Originaire de Claix, connaissant Kinan depuis déjà plusieurs années, j'ai souhaité m'investir dans un projet qui avait du sens tant social qu'écologique. Le Pacte est en accord avec mes valeurs et constitue un premier engagement dans ma vie. »",
  },
  {
    name: "Noé Faure",
    role: "Développeur",
    photo: "https://i.ibb.co/xtWQdBCT/Frame-1171276579.png",
    bio: "« Passionné par l’informatique depuis tout petit, j’ai commencé à coder à l’âge de 11 ans. Quand Kinan m’a parlé du PACTE, j’ai tout de suite eu envie de m’impliquer en développant l’application. C’est un vrai plaisir de contribuer à un projet local et concret, qui mêle engagement, entraide et technologie : trois choses qui me tiennent vraiment à cœur. »",
  },
];

export default function QuiSommesNous() {
  return (
    <div className="min-h-screen bg-white text-black">
      <NavBar />

        <section className="mx-auto max-w-[1519px] px-4 sm:px-6 lg:px-8 mt-6">
        <div className="relative overflow rounded-3xl shadow-lg">
            <div
            aria-hidden
            className="absolute inset-0 rounded-3xl bg-gradient-to-t from-[#E35EA7] to-[#FFDDEA]"
            />
            <div
            aria-hidden
            className="absolute inset-0 rounded-3xl bg-center bg-cover opacity-60"
            style={{ backgroundImage: `url(${aboutBg})` }}
            />
            <div aria-hidden className="absolute inset-0 rounded-3xl bg-black/10" />
            <div
            className="
                relative flex flex-col items-center justify-center text-center
                p-5 sm:p-8 lg:p-12
                min-h-[620px] lg:min-h-[840px]   /* = mêmes hauteurs que le hero principal */
            "
            >
            <h1 className="text-3xl sm:text-5xl font-asap font-semibold text-white">
                Qui sommes-nous ?
            </h1>
            <p className="mt-3 max-w-3xl text-white/90 text-sm sm:text-base">
                Promouvons nos Acteurs Claixois Tous Ensemble 
            </p>

            <div className="mt-6 flex items-center justify-center gap-3">
                <a
                href="#mission"
                className="inline-flex items-center justify-center rounded-full bg-black text-white
                            px-6 py-3 text-sm font-medium shadow-[0_10px_24px_rgba(0,0,0,0.35)] hover:opacity-90 transition"
                >
                Notre mission
                </a>
                <a
                href="#equipe"
                className="inline-flex items-center justify-center rounded-full bg-white text-neutral-900
                            px-6 py-3 text-sm font-medium ring-1 ring-black/10 hover:bg-white/95 transition"
                >
                Découvrir l’équipe
                </a>
            </div>
            </div>

            <div aria-hidden className="pointer-events-none absolute inset-0 rounded-3xl ring-1 ring-white/30" />
        </div>
        </section>

        <section
        id="mission"
        className="mx-auto max-w-[1519px] px-4 sm:px-6 lg:px-8 py-12 sm:py-16"
        >
        <div className="rounded-[22px] sm:rounded-3xl bg-[#F6F6F7] border border-black/5 shadow-[0_6px_20px_rgba(0,0,0,0.06)] p-8 sm:p-10">
            <h2 className="text-2xl sm:text-3xl font-asap font-semibold mb-10 text-center">
            Notre raison d’être
            </h2>

            <div className="grid grid-cols-1 md:grid-cols-3 gap-8 lg:gap-12 text-neutral-800">
            <div className="text-center md:text-left">
                <h3 className="text-lg sm:text-xl font-semibold mb-3">Mission</h3>
                <p className="text-sm sm:text-base leading-relaxed">
                Fédérer et recenser les commerçants, rendre la consommation plus pratique et ludique, favoriser le circuit-court et Promouvoir nos Acteurs Claixois Tous Ensemble.
                </p>
            </div>

            <div className="text-center md:text-left">
                <h3 className="text-lg sm:text-xl font-semibold mb-3">Vision</h3>
                <p className="text-sm sm:text-base leading-relaxed">
                Un lien de proximité entre les acteurs claixois et les habitants, favorisant une consommation locale et régulière.
                </p>
            </div>

            <div className="text-center md:text-left">
                <h3 className="text-lg sm:text-xl font-semibold mb-3">Valeurs</h3>
                <ul className="text-sm sm:text-base leading-relaxed list-disc list-inside space-y-1">
                <li>Proximité & local</li> 
                <li>Utile & fonctionnel</li>
                <li>Engagement & action</li>
                <li>Ludique & dynamique</li>
                </ul>
            </div>
            </div>
        </div>
        </section> 

      <section className="mx-auto max-w-[1519px] px-4 sm:px-6 lg:px-8 pb-10 sm:pb-14">
        <div className="rounded-[22px] sm:rounded-3xl bg-[#F6F6F7]  shadow-[0_6px_20px_rgba(0,0,0,0.06)] p-6 sm:p-8">
          <div className="grid grid-cols-1 md:grid-cols-[320px_1fr] gap-6 md:gap-8 items-center">
            <div className="w-full">
              <div className="aspect-[4/5] rounded-2xl overflow-hidden bg-neutral-200 border border-black/10">
                <img src="https://pacte-claix.fr/assets/images/PPKF%20v2.jpg" alt="Président" className="w-full h-full object-cover" /> 
              </div>
            </div>
            <div>
              <h3 className="text-xl sm:text-2xl font-semibold">Le mot du président</h3>
              <p className="mt-3 text-sm sm:text-base text-neutral-700 leading-relaxed">
                « Le PACTE (Promouvons nos Acteurs Claixois Tous Ensemble) est une association claixoise qui fédère et valorise les commerces locaux.

<br/>L’objectif de cette association est de se préoccuper des problématiques et des besoins des commerçants. L’idée est de proposer des solutions simples qui donneront un nouvel élan au Bourg et à Pont Rouge.

<br/>À partir du mois de Juin 2025, vous retrouverez l'appli du PACTE sur le Play Store et l'App Store, regroupant plus de 10 de nos commerçants claixois, du centre bourg comme de Pont Rouge. »
              </p>
              <div className="mt-4 text-sm text-neutral-600">
                <span className="font-semibold">Kinan FAURE</span> — Président du PACTE 
              </div>
              <div className="mt-5 flex gap-3">
                <a
                  href="#equipe"
                  className="inline-flex items-center justify-center rounded-full bg-black text-white px-5 py-2.5 text-sm font-medium shadow-[0_10px_24px_rgba(0,0,0,0.35)] hover:opacity-90 transition"
                >
                  Echangeons ensemble
                </a>
                <a
                  href="/devenir-partenaire"
                  className="inline-flex items-center justify-center rounded-full bg-white text-neutral-900 px-5 py-2.5 text-sm font-medium ring-1 ring-black/10 hover:bg-white/95 transition"
                >
                  Devenir partenaire
                </a>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section id="equipe" className="mx-auto max-w-[1519px] px-4 sm:px-6 lg:px-8 pb-10 sm:pb-16">
        <h2 className="text-2xl sm:text-3xl font-asap font-semibold mb-6">L’équipe & les collaborateurs</h2>
        <p className="text-[15px] sm:text-base text-neutral-700 max-w-3xl">
          Une équipe bénévole et engagée qui fait vivre l’association au quotidien aux côtés
          des commerçants et partenaires claixois.
        </p>

        <div className="mt-7 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6 lg:gap-7">
          {TEAM.map((p) => (
            <TeamCard key={p.name} person={p} />
          ))}
        </div>
      </section>

      <FooterGradient />
    </div>
  );
}


function Card({ children }) {
  return (
    <div className="rounded-[22px] sm:rounded-3xl bg-[#F6F6F7] border border-black/5 shadow-[0_6px_20px_rgba(0,0,0,0.06)] p-6 sm:p-7 md:p-8">
      {children}
    </div>
  );
}

function Spacer() {
  return <div className="mt-5 h-4" />;
}

function TeamCard({ person }) {
  return (
    <div className="rounded-3xl border border-black/10 bg-white shadow-[0_10px_24px_rgba(0,0,0,0.06)] overflow-hidden">
      <div className="aspect-[16/10] bg-neutral-200">
        <img src={person.photo} alt={person.name} className="w-full h-full object-cover" /> 
      </div>
      <div className="p-5 sm:p-6">
        <div className="flex items-baseline justify-between gap-3">
          <h3 className="text-lg font-semibold">{person.name}</h3>
          <span className="text-xs px-2 py-1 rounded-full bg-[#F3F3F4] border border-black/5">
            {person.role}
          </span>
        </div>
        <p className="mt-2 text-[15px] text-neutral-700 leading-relaxed">{person.bio}</p>
      </div>
    </div>
  );
}